import { ComponentProps } from 'react'

import { joinStyles } from '@/utils/app/theme'

import * as styles from './index.css'

type GridProperties = ComponentProps<'div'>

export const Grid = ({
    className,
    ...properties
}: Readonly<GridProperties>): JSX.Element => {
    return (
        <div
            className={joinStyles(styles.root, className)}
            {...properties}
        />
    )
}
